/*
  Colour-selector tracking (ticket 3ce7c862 — packshot vs pastilles A/B via Shopify Rollouts).
  Loaded by snippets/sibling-products.liquid on every product that renders the colour (sibling) picker.
  Two hidden line-item properties ride every add-to-cart from that page (both forms: the main one and the
  sticky "--alt" twin), hidden from the customer by their leading underscore:
    _selecteur_coloris      packshot | pastilles — the format the page showed (set in Liquid)
    _coloris_via_selecteur  oui | non — the visitor reached THIS colour by clicking a tile / pastille of
                            the selector (set here: the clicked target handle is kept in sessionStorage
                            and compared with the handle of the page that loads next).
*/
(function () {
  var KEY = 'lp-coloris-via-selecteur';
  var script = document.currentScript || document.querySelector('script[data-colour-selector-handle]');
  var handle = script ? script.getAttribute('data-colour-selector-handle') : '';

  function read() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function write(value) { try { sessionStorage.setItem(KEY, value); } catch (e) { /* storage blocked: stays "non" */ } }

  var arrivedViaSelector = handle !== '' && read() === handle;
  document.querySelectorAll('input[data-colour-selector-tracking="via"]').forEach(function (input) {
    input.value = arrivedViaSelector ? 'oui' : 'non';
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.sibling-item');
    if (!link) return;
    var match = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (match) write(match[1]);
  }, true);
})();
